import React from 'react'
import mount from '../lib/mount'
import App from '../components/App'
import UserFollowButton from '../components/UserFollowButton'
import UserFollowersCount from '../components/UserFollowersCount'

document.addEventListener('turbolinks:load', () => {
  document.querySelectorAll("[id^='react-user-follow-button-']").forEach((match) => {
    const data = JSON.parse(match.getAttribute('data'))
    mount(
      match,
      <App>
        <UserFollowButton
          username={data.username}
          href={data.href}
          followersCount={data.followersCount} />
      </App>,
    )
  })

  document.querySelectorAll("[id^='react-user-followers-count-']").forEach((match) => {
    const data = JSON.parse(match.getAttribute('data'))
    mount(
      match,
      <App>
        <UserFollowersCount
          username={data.username}
          followersCount={data.followersCount}
          format={data.format} />
      </App>,
    )
  })
})
